import { ScrollVideo } from './components/ScrollVideo'
import { Navbar } from './components/Navbar'
import { Hero } from './components/Hero'
import { Capability } from './components/Capability'

const HERO_VIDEO =
  'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260729_102822_0e6c87e8-c141-4744-bf32-ad30db296371.mp4'
const HERO_POSTER =
  'https://images.higgs.ai/?default=1&output=webp&url=https%3A%2F%2Fd8j0ntlcm91z4.cloudfront.net%2Fuser_38xzZboKViGWJOttwIXH07lWA1P%2Fhf_20260729_102822_0e6c87e8-c141-4744-bf32-ad30db296371.mp4&w=1920&q=85'

export default function App() {
  return (
    <>
      {/* Scroll-scrubbed video background */}
      <ScrollVideo src={HERO_VIDEO} poster={HERO_POSTER} />

      {/* Foreground content */}
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          {/* Spacer for scroll video length */}
          <div className="h-[80vh]" aria-hidden="true" />
          <Capability />
        </main>
      </div>
    </>
  )
}